import { FormField } from './field';
import { FieldControl } from '@signature-it/ngx-generic/enums';
import { FormFieldFactory } from './field-factory';
import { OptionDTO } from './option';

export class NgxComponentField extends FormField {
    controlType = FieldControl.NGX_COMPONENT;
	ngxComponentHtml: string;
	fieldsList: [];
	optionsJs:string;
	componentGroupId: number;
	options: OptionDTO[] = [];
	showHtmlOnViewMode: boolean = false;
	constructor(attributes?: Object) {
	    super(attributes);
		this.ngxComponentHtml = attributes['ngxComponentHtml'] || '';
		this.fieldsList = attributes['fieldsList'] ||  [];
		this.optionsJs = attributes['optionsJs'] || null;
		this.updateValuesByOtherAns = true;
		this.componentGroupId = <number>attributes['componentGroupId'] || 0;
		this.options = attributes['options'] || [];
		if (attributes['additionalInfo'] && typeof attributes['additionalInfo'] === 'string') {
				this.additionalInfo = JSON.parse(attributes['additionalInfo']);
		} else {
			this.additionalInfo = attributes['additionalInfo'] || [];
		}
		this.showHtmlOnViewMode = ((this.additionalInfo['showHtmlOnViewMode'] === 'true') || !!this.additionalInfo['showHtmlOnViewMode']) ?? false;
	}

	getFieldList() {
		let formFields: FormField[] = [];
		let hiddenQuestionId = +(this.questionId + 0.01).toFixed(2);
		this.fieldsList.forEach(hiddenField => {
			formFields.push(FormFieldFactory.createHiddenField(hiddenField, {
				questionId: hiddenQuestionId,
				parentStepHasDependRule: this.parentStepHasDependRule
			}));
			hiddenQuestionId = +(hiddenQuestionId + 0.01).toFixed(2);
		});
		//add validation indicate field
		formFields.push(FormFieldFactory.createHiddenField(this.getIsValidKey(), {
			questionId: hiddenQuestionId,
			ignoreInAns: true,
			required: true,
			value: 'true'
		}));
		return formFields;
	}

	getIsValidKey() {
		return this.key + '_is_valid';
	}

	public static getIsValidKey(key) {
		return key + '_is_valid';
	}
}
